import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-avatar',
  templateUrl: './contact-avatar.component.html',
  styleUrls: ['./contact-avatar.component.css']
})
export class ContactAvatarComponent implements OnInit {

  @Input() presenceClass!: string;
  @Input() avatarUrl!: string;
  @Input() toolTip!: string;
  @Input() toolTipPosition: string = 'right';
  @Input() showPresenceIcon: boolean = false;
  @Input() presenceIcon: string | null = null;
  @Input() size: string = 'xs';

  constructor() { }

  ngOnInit() {
  }

}
